<template>
  <div class="stlc_icon_list_container stlc_social_networks">
    <template v-for="(snItem, index) in socialNetworkLinks">
      <a
        v-if="snItem?.SocialNetwork?.ShowInList"
        :key="'sn_' + index"
        :href="snItem.Url"
        :title="snItem.SocialNetwork.Name"
        class="stlc_list_icon_item"
        target="_blank"
      >
        <img
          v-if="snItem.SocialNetwork.LinkIconUrl"
          :alt="snItem.SocialNetwork.Name"
          :src="snItem.SocialNetwork.LinkIconUrl"
          class="stlc-store-list-icons"
        />
        <span v-if="snItem.SocialNetwork.LinkText">
          {{ snItem.SocialNetwork.LinkText }}
        </span>
      </a>
      <span v-if="socialIconsLineBreaks" :key="index" class="stlc_break_line"></span>
    </template>
  </div>
</template>

<script>
export default {
  name: 'rfp-storelocator-social-links',
  props: {
    socialNetworkLinks: {
      type: Array,
      required: true,
    },
    storeName: {
      type: String,
      required: true,
    },
  },
  computed: {
    socialIconsLineBreaks() {
      if (this.socialNetworkLinks && this.socialNetworkLinks.length) {
        return this.socialNetworkLinks.some((l) => l.SocialNetwork.LinkText);
      }

      return false;
    },
  },
};
</script>
